import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FaLock } from 'react-icons/fa';

const HeaderBar = () => {
  return (
    <header className="sticky top-0 z-50 bg-black text-white py-4 shadow-md">
      <div className="max-w-xl mx-auto px-4 flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-3">
            <img src="/wie_logo.svg" alt="WIE" className="h-10 w-10 object-contain" />
            <div className="h-8 w-px bg-gray-700"></div>
            <img src="/dpc_logo.svg" alt="DPC" className="h-10 w-auto object-contain" />
          </div>
          <div className="hidden sm:block border-l border-gray-700 pl-4">
            <h1 className="text-sm font-bold leading-tight font-arial">The Dynamic Pay Claim</h1>
          </div>
        </div>
        <div className="flex items-center space-x-2 text-xs text-black bg-white px-3 py-2 rounded-none border border-gray-300">
          <SafeIcon icon={FaLock} className="w-3 h-3" />
          <span className="font-bold font-arial">SECURE</span>
        </div>
      </div>
    </header>
  );
};

export default HeaderBar;